import { toast } from 'react-toastify';
import { SMSIconFilled } from '@rsos/assets/icons';
import { Box, Text, Button } from '@rsos/components/capstone/base';
import {
  CALL_REROUTED,
  CALL_OUT_OF_JURISDICTION,
} from '@rsos/constants/collaborator';
import { formatInternationalPhoneNumberHuman } from '@rsos/utils/internationalPhoneNumberUtils';

export const toastRcsAvailable = (callerId, onViewEvent, onClose) => {
  const toastOptions = {
    autoClose: false,
    bodyClassName: 'Toastify__overwrite-body',
    draggable: false,
    pauseOnFocusLoss: false,
    pauseOnHover: false,
    position: 'top-center',
    closeButton: true,
    onClose,
  };

  const toastMessage = (
    <Box align="center" flow={10} horizontal>
      <Box align="center" flow={10} horizontal width="325px">
        <SMSIconFilled height={24} width={25} />
        <Box width="320px">
          <Text size="normal">
            RCS Message Available for{' '}
            {formatInternationalPhoneNumberHuman(callerId)}
          </Text>
        </Box>
      </Box>
      <Box align="center" justify="flex-end" horizontal width="300px">
        <Button
          size={'small'}
          btnType="tertiary"
          onClick={() => {
            onViewEvent(callerId);
          }}
        >
          View event
        </Button>
      </Box>
    </Box>
  );

  toast(toastMessage, {
    ...toastOptions,
    className: 'Toastify__rcs-available',
    toastId: `toastRcsAvailable-${callerId}`,
  });
};

/**
 * Get collaborator type display name based on collaborator type value.
 * @param {String} collaboratorType - Collaborator type
 * @returns String
 */
export const getCollaboratorTypeDisplayName = (
  collaboratorType,
  pairedAccountName,
) => {
  switch (collaboratorType) {
    case CALL_REROUTED:
      return `CALL ROUTED to ${pairedAccountName}`;
    case CALL_OUT_OF_JURISDICTION:
      return `CALL OUT OF JURISDICTION`;
    default:
      return null;
  }
};
